import "core-js/stable";
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./assets/css/global.css"
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
// Vue.use(ElementUI);
import { Button, Form, FormItem, Input, Message ,Loading,Checkbox,CheckboxGroup,CheckboxButton,Cascader,Pagination } from 'element-ui';
Vue.use(Button).use(Form).use(FormItem).use(Input).use(Checkbox).use(CheckboxGroup).use(CheckboxButton).use(Cascader).use(Pagination);
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service;
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
